// Copyright (c) 2023 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  DeleteRecentNarrativeRequestSchema,
  SearchRecentNarrativesRequestSchema
} from "../../generated/wisetime/user/preferences/v4/preferences_pb"
import { Init } from "../../app/rpc"

export const searchRecentNarratives = createAction<Init<typeof SearchRecentNarrativesRequestSchema>>("narratives/search-recent-narratives")
export const deleteRecentNarrative = createAction<Init<typeof DeleteRecentNarrativeRequestSchema>>("narratives/delete-recent-narrative")
